<script>
    import Cluster from "vue2-google-maps/dist/components/cluster";

    export default {
        extends: Cluster,
        props: {
            enableRetinaIcons: {
                default: true
            },
            zoomOnClick: {
                default: true,
            },
            gridSize: {
                default: 48,
            },
            styles: {
                default: () => {
                    return [
                        {
                            url: '/images/marker-cluster.svg',
                            textColor: 'white',
                            width: 48,
                            height: 48,
                            textSize: 14,
                            fontFamily: 'Bryant Pro, Arial, sans-serif',
                        },
                    ];
                }
            }
        },
    }
</script>
